





























import { Component, Prop, Vue } from "vue-property-decorator";
import { MapboxMap } from "vue-mapbox-ts-legacy";
import * as turf from "@turf/turf";
@Component({
  components: {
    MapboxMap,
  },
})
export default class MapBox extends Vue {
  @Prop() readonly coords!: number[][];

  private token: string =
    "pk.eyJ1IjoicHJvZ3JhbW1lcmZyb21iZWxhcnVzIiwiYSI6ImNsNnFkeGoxZzBnMmQzYm93MTZ2Z292NjMifQ.os1myXVMxjydCu8AsyagPw";
  public steps = 500;
  public counter = 0;
  private map: any;

  get Center(): number[] {
    let sumLat: number = 0;
    let sumLon: number = 0;
    this.coords.map((coord) => {
      sumLat += coord[0];
      sumLon += coord[1];
    });
    return [sumLat / this.coords.length, sumLon / this.coords.length];
  }
  protected lines = {
    type: "FeatureCollection",
    features: [
      {
        type: "Feature",
        geometry: {
          type: "LineString",
          coordinates: [...this.coords, this.coords[0]],
        },
      },
    ],
  };
  protected point = {
    type: "FeatureCollection",
    features: [
      {
        type: "Feature",
        properties: {
          bearing: 0,
        },
        geometry: {
          type: "Point",
          coordinates: this.coords[0],
        },
      },
    ],
  };
  protected layer = {
    id: "line-animation",
    type: "line",
    source: {
      type: "geojson",
      data: this.lines,
    },
    layout: {
      "line-join": "round",
      "line-cap": "round",
    },
    paint: {
      "line-color": "#2F2322",
      "line-width": 3,
      "line-opacity": 0.8,
    },
  };
  protected loaded(map: any): void {
    this.map = map;

    if (map._containerWidth <= 350) {
      map.setZoom(9);
    }

    map.addLayer(this.layer);
    map.addSource("point", {
      type: "geojson",
      data: this.point,
    });
    map.addLayer({
      id: "point",
      source: "point",
      type: "symbol",
      layout: {
        "icon-image": "car-15",
        "icon-size": 2,
        "icon-rotate": ["get", "bearing"],
        "icon-rotation-alignment": "map",
        "icon-allow-overlap": true,
        "icon-ignore-placement": true,
      },
    });
    this.animation(), this.animate();
  }
  // protected resize(map: any): void {
  //   if(map._containerWidth <= 350) {
  //     // console.log('here')
  //      map.setZoom(9)
  //   }
  // }
  protected animation(): void {
    const line = turf.lineString(this.lines.features[0].geometry.coordinates);
    const lineDistance = turf.length(line, { units: "kilometers" });
    const arc = [];

    for (let i = 0; i < lineDistance; i += lineDistance / this.steps) {
      const segment = turf.along(line, i);
      arc.push(segment.geometry.coordinates);
    }
    this.lines.features[0].geometry.coordinates = arc;
  }

  protected animate() {
    let start = this.lines.features[0].geometry.coordinates[
      this.counter >= this.steps ? this.counter - 1 : this.counter
    ];

    let end = this.lines.features[0].geometry.coordinates[
      this.counter >= this.steps ? this.counter : this.counter + 1
    ];
    if (!start || !end) {
      this.counter = 0;
      end = this.lines.features[0].geometry.coordinates[this.counter];
    }

    this.point.features[0].geometry.coordinates = this.lines.features[0].geometry.coordinates[
      this.counter
    ];
    this.point.features[0].properties.bearing = turf.bearing(
      turf.point(start),
      turf.point(end)
    );

    this.map.getSource("point").setData(this.point);

    if (this.counter <= this.steps) {
      requestAnimationFrame(this.animate);
    }
    ++this.counter;
  }
}
